/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{getOrigin as s}from"../core/urlUtils.js";const t=new Set(["elevation3d.arcgis.com","js.arcgis.com","jsdev.arcgis.com","jsqa.arcgis.com","static.arcgis.com"]);function r(s){return!!s&&s.length>4&&s.startsWith("AAPK")}function c(r){const c=s(r,!0);return!!c&&(c.endsWith(".arcgis.com")&&!t.has(c)&&!r.endsWith("/sharing/rest/generateToken"))}export{r as isApiKey,c as supportsApiKey};
